import React, { useState } from "react";
import { Card, Tag, Tooltip, Typography, Space, Row } from "antd";
import { MapPin, Users, Building2 } from "lucide-react";
import type { Location } from "../../../../../types/location";
import LocationSettings from "./LocationSettings";

const { Text, Title } = Typography;

interface LocationCardProps {
  location: Location;
}

const LocationCard: React.FC<LocationCardProps> = ({ location }) => {
  const [open, setOpen] = useState<boolean>(false);

  const [locationData, setLocationData] = useState<Location>(location);

  return (
    <>
      <Card
        onClick={() => setOpen(!open)}
        hoverable
        style={{ height: "100%" }}
        cover={
          <div
            style={{
              height: 128,
              background: locationData.color
                ? `linear-gradient(to right, ${locationData.color}, ${locationData.color})`
                : "linear-gradient(to right, #1890ff, #096dd9)",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                bottom: 16,
                left: 16,
                right: 16,
                color: "#fff",
              }}
            >
              <Space>
                <MapPin size={16} />
                <Text style={{ color: "#fff", margin: 0 }}>
                  {locationData.city}, {locationData.state}
                </Text>
              </Space>
              <Title level={4} style={{ color: "#fff", margin: "8px 0 0 0" }}>
                {locationData.name}
              </Title>
            </div>
          </div>
        }
      >
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <Tooltip title={locationData.address}>
            <Text type="secondary" ellipsis>
              {locationData.address}
            </Text>
          </Tooltip>

          <Row justify="space-between" align="middle">
            <Space>
              <Users size={16} />
              <Text type="secondary">
                {locationData.departments.reduce(
                  (acc, dept) => acc + dept.employeeCount!,
                  0
                )}{" "}
                Employees
              </Text>
            </Space>
            <Space>
              <Building2 size={16} />
              <Text type="secondary">
                {locationData.departments.length} Depts
              </Text>
            </Space>
          </Row>

          <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 16 }}>
            <Tag color="blue">{locationData.zipCode}</Tag>
          </div>
        </Space>
      </Card>
      {open && (
        <LocationSettings
          onClose={() => setOpen(!open)}
          location={locationData}
          onCreate={(value) => setLocationData(value)}
        />
      )}
    </>
  );
};

export default LocationCard;
function userEffct(arg0: () => void, arg1: Location[]) {
  throw new Error("Function not implemented.");
}
